import React from 'react';
import { StyledLink } from './commonStyle';
import { translate } from '../../common/translation/translate';

const rightsRegardingPersonalInformationSection = 'rightsregardingpersonalinformation';

export const UsStatePrivacyPolicyLink = () => {
    return (
        <StyledLink href={`/legal/privacy/#${rightsRegardingPersonalInformationSection}`}>
            {translate('usStatePrivacyRights')}
        </StyledLink>
    );
  
};